import { render } from "./LaborContracts.vue?vue&type=template&id=73e94762&scoped=true"
import script from "./LaborContracts.vue?vue&type=script&lang=js"
export * from "./LaborContracts.vue?vue&type=script&lang=js"

import "./LaborContracts.vue?vue&type=style&index=0&id=73e94762&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e94762"]])

export default __exports__